import { Decimal } from 'decimal.js';
import { PaycodeEndpoints } from './endpoints';
import { Paycode } from '../models';
import * as schemas from './schemas';
import { getToken } from '~/apps/shared/services/token';
import * as net from '~/lib/net';

export async function getPaycodeById(paycodeId: string): Promise<Paycode> {
  const data = await net.apiGet(PaycodeEndpoints.getPaycodeById(paycodeId), getToken());
  return schemas.PaycodeSchema.load(data);
}

export type PaycodeListFilter = {
  filter?: string;
  offset?: number;
  limit?: number;
  hideExpired?: boolean,
};

export async function getOrgPaycodes(orgId: string, flt: PaycodeListFilter=null): Promise<Paycode[]> {
  const data = await net.apiGet(PaycodeEndpoints.getOrgPaycodes(orgId, flt), getToken());
  return schemas.PaycodeListSchema.load(data);
}
